import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { ShopOrderState } from '@x/ecommerce-shop/app/core/order/state/shop-order.state';
import { IShopOrder } from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';

@Component({
  selector: 'x-region-button-icon',
  templateUrl: './region-button-icon.component.html',
  styleUrls: ['./region-button-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-region-button-icon' },
})
export class RegionButtonIconComponent {
  @Select(ShopOrderState.order) shopOrder$: Observable<IShopOrder>;
}
